import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import { FAILURE_COUNTRIES, REQUEST_COUNTRIES, SUCCESS_COUNTRIES } from './actions';

export function countriesReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_COUNTRIES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_COUNTRIES: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_COUNTRIES:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
